<template>
  <div
    class="checkbox-wrap"
    @keydown.enter="onChange"
  >
    <label :for="name">
      <input
        :id="name"
        type="checkbox"
        :value="isChecked ? 1 : 0"
        :name="name"
        :disabled="disabled"
        :checked="isChecked"
        @click="onChange"
      />
      <slot>
        <span
          v-if="label.length"
          class="checkbox-label"
        >
          <span class="main-label"> {{ label }}</span>
        </span>
      </slot>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'CheckboxBase',
    props: {
      label: {
        type: String,
        default: '',
        required: false
      },
      name: {
        type: String,
        required: true
      },
      isChecked: {
        type: Boolean,
        default: false,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    methods: {
      onChange(value) {
        this.$emit('change', value)
      }
    }
  }
</script>
